import { css } from "styled-components";

export const ProgressBarStyles = css(
    ({ theme }) => css`
        .ProgressBar {
            background-color: ${theme.palette.gray[50]};
            height: 0.25rem;
        }
        .ProgressBarTrack {
            border-radius: ${theme.borderRounded};
        }
    `,
);
